export default function (element, data) {
    const offset = parseInt(getComputedStyle(element).getPropertyValue("--card-sticky-pos"));
    //const parent = element.parentElement;
    const anchor = element.querySelector(".card-anchor");
    //const parentBaseRect = parent.getBoundingClientRect();

    element.style.position = 'relative';
    //const elementBaseRect = element.getBoundingClientRect();

    if (anchor) {
        const anchorRect = anchor.getBoundingClientRect();
        const anchorTopInDocument = anchorRect.top + window.scrollY - offset;

        anchor.remove();

        const documentAnchor = document.createElement('div');
        documentAnchor.id = anchor.id;
        documentAnchor.style.position = 'absolute';
        documentAnchor.style.top = `${anchorTopInDocument}px`;
        documentAnchor.style.left = `${anchorRect.left + window.scrollX}px`;
        documentAnchor.style.width = '1px';
        documentAnchor.style.height = '1px';
        documentAnchor.style.pointerEvents = 'none';
        documentAnchor.style.visibility = 'hidden';

        document.body.appendChild(documentAnchor);
    }

    element.style.position = 'sticky';
    //const elementBaseTop = elementBaseRect.top - parentBaseRect.top;

    //function update() {
        //const parentRect = parent.getBoundingClientRect();
        //const parentHeight = parentRect.height;
        //const parentTop = parentRect.top - parseInt(offset) + elementBaseTop;
        //const relativeTop = Math.max(0, Math.min(1, -parentTop / (parentHeight - (element.offsetHeight + offset))));
        //const scale = 1 - (relativeTop * 0.15);
        //element.style.transform = `scale(${scale})`;
    //}

    //window.addEventListener("scroll", update, { passive: true });
    //update();
}
